import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedMenuItemLabel: null,
  selectSecondMenuItemLabel: null
};

const selectedMenuItemSlice = createSlice({
  name: 'selectedMenuItem',
  initialState,
  reducers: {
    setSelectedMenuItemLabel: (state, action) => {
      state.selectedMenuItemLabel = action.payload;
    },
    setSecondSelectedMenuItemLabel: (state, action) => {
      state.selectSecondMenuItemLabel = action.payload
    }
  },
});

export const { setSelectedMenuItemLabel, setSecondSelectedMenuItemLabel } = selectedMenuItemSlice.actions;

export default selectedMenuItemSlice.reducer;
